import React from 'react';
import { Autocomplete } from '@costar/theme-ui-autocomplete';
import { createCategoriesSelector } from './selectors/categories-selector.esm.js';
import { defaultCategorySelector } from './selectors/default-category-selector.esm.js';
import { keys } from '../../constants/keys.esm.js';
import { createCategoryChangeCallbackSelector } from './selectors/category-change-callback-selector.esm.js';
import { currentCategorySelector } from './selectors/current-category-selector.esm.js';

var isOptionEqualToValue = function isOptionEqualToValue(a, b) {
  return a.id === b.id;
};
var getOptionLabel = function getOptionLabel(o) {
  return o.label;
};
var isSelectAllOption = function isSelectAllOption(o) {
  return o.id === keys.allFields;
};
function createAvailableListHeader() {
  var categoriesSelector = createCategoriesSelector();
  var categoryChangeCallbackSelector = createCategoryChangeCallbackSelector();
  function AvailableListHeader(props) {
    return /*#__PURE__*/React.createElement(Autocomplete, {
      mode: "select",
      disableClearable: true,
      fixToInputWidth: true,
      options: categoriesSelector(props),
      fontSize: "sm",
      width: "100%",
      isOptionEqualToValue: isOptionEqualToValue,
      defaultValue: defaultCategorySelector(props),
      value: currentCategorySelector(props),
      placeholder: props.resources.allFields(),
      fullWidthPopover: true,
      onChange: categoryChangeCallbackSelector(props),
      getOptionLabel: getOptionLabel,
      isSelectAllOption: isSelectAllOption
    });
  }
  AvailableListHeader.displayName = 'AvailableListHeader';
  return AvailableListHeader;
}

export { createAvailableListHeader };
//# sourceMappingURL=available-list-header.esm.js.map
